import React, { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { fetchIsAdmin } from '../utils/admin';
import SiteFooter from './SiteFooter';

export default function RequireAdmin({ children }) {
  const [state, setState] = useState('loading');

  useEffect(() => {
    let mounted = true;
    let generation = 0;
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      const gen = ++generation;
      if (!user) {
        if (mounted && gen === generation) setState('anon');
        return;
      }
      if (mounted) setState('loading');
      const allowed = await fetchIsAdmin(user);
      if (!mounted || gen !== generation) return;
      // Ignore if auth already moved to a different account (same generation can't happen).
      if (auth.currentUser?.uid && auth.currentUser.uid !== user.uid) return;
      setState(allowed ? 'ok' : 'forbidden');
    });
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  if (state === 'loading') return null;
  if (state === 'anon') return <Navigate to="/login" replace />;
  if (state === 'forbidden') {
    return (
      <div className="page-shell">
        <div className="empty-page">
          <h1>Not authorized</h1>
          <p className="lede">This page is only for the site operator.</p>
          <Link className="btn-ghost" to="/">
            Back to home
          </Link>
        </div>
        <SiteFooter />
      </div>
    );
  }

  return children;
}
